import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Bell, CalendarDays, Send } from 'lucide-react';

const DashboardHome = () => {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-3xl font-bold text-gray-900">Bienvenue sur votre espace client</h1>
      <p className="text-gray-600">Voici un aperçu de vos contenus prêts à publier et de votre activité récente.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <Send className="w-8 h-8 text-blue-600" />
            <div>
              <p className="text-sm text-gray-500">Posts IA prêts</p>
              <p className="text-xl font-semibold text-gray-900">3 brouillons</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <CalendarDays className="w-8 h-8 text-green-600" />
            <div>
              <p className="text-sm text-gray-500">Publications programmées</p>
              <p className="text-xl font-semibold text-gray-900">2 à venir</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <Bell className="w-8 h-8 text-yellow-500" />
            <div>
              <p className="text-sm text-gray-500">Notifications</p>
              <p className="text-xl font-semibold text-gray-900">1 nouvelle</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DashboardHome;
